import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { formatDate, hubspotDealUrl } from "../selectors";

/** Closed deals that reached a pilot step: the win/loss record. */
export function PastPilotsTable({ pilots }) {
  if (!pilots.length) {
    return <div className="pl-empty">No closed pilots yet.</div>;
  }

  return (
    <div className="pl-table-wrap">
      <table className="pl-table">
        <thead>
          <tr>
            <th className="pl-left">Deal</th>
            <th className="pl-left">Outcome</th>
            <th className="pl-left">Furthest playbook step</th>
            <th className="pl-left">Owner</th>
            <th>Closed</th>
            <th aria-label="HubSpot link" />
          </tr>
        </thead>
        <tbody>
          {pilots.map((pilot) => (
            <tr key={pilot.dealId}>
              <td className="pl-left">
                <span className="pl-deal-name">{pilot.name}</span>
                {pilot.companyType ? (
                  <span className="pl-deal-sub">{pilot.companyType}</span>
                ) : null}
              </td>
              <td className="pl-left">
                <span
                  className={`pl-badge ${pilot.isWon ? "pl-badge--good" : "pl-badge--bad"}`}
                >
                  {pilot.isWon ? "Won" : pilot.stage || "Lost"}
                </span>
              </td>
              <td className="pl-left">{pilot.subStage?.label || "—"}</td>
              <td className="pl-left">{pilot.owner || "—"}</td>
              <td>{formatDate(pilot.closeDate)}</td>
              <td>
                <a
                  className="pl-icon-link"
                  href={hubspotDealUrl(pilot.dealId)}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Open ${pilot.name} in HubSpot`}
                >
                  <FaExternalLinkAlt aria-hidden="true" />
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
